//按钮
<template>
  <div :class="{'button':true,'disabled':disabled,'block':block}" @click="buttonClick">{{title}}</div>
</template>
<script>
export default {
  props: {
    title: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    buttonClick() {
      if (this.disabled) {
        return
      }
      this.$emit('buttonClick')
    }
  }
}
</script>
<style lang="less" scoped>
.button {
  .h(40);
  .radius(20);
  background-color: @themeBg;
  text-align: center;
  .lh(40);
  color: #fff;
  .fs(16);
}
.disabled {
  background-color: #ccc;
}
.block {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/button/button.vue